import { ProductScreenshot } from 'components/ProductScreenshot';
import { ProductVideo } from 'components/ProductVideo';
import * as React from 'react';
export default {
  ProductScreenshot,
  ProductVideo,
  React
};